export default __webpack_public_path__ + "static/media/logo_white.7153f30b.svg";